export default "__VITE_ASSET__DVbFCKbY__"